<div id="not-found-container">
  <div class="not-found-content">
    <div>
      <h1>Planned Maintenance in Progress</h1>
      <div class="text">Synergatika.gr is currently undergoing routine maintenance
      </div>
      <div class="text">to ensure you get the best experience.
      </div>
      <h3>We will back soon!</h3>
    </div>
  </div>
</div>